export const EmployeeRoutes = {
    employees: (origin: string) => `${origin}/search/employee`,
    employeeCompanies: (origin: string) => `${origin}/search/employee/company-filters`,
    employeeJobs: (origin: string) => `${origin}/search/employee/job-filters`,
    employeeActivity: (origin: string) =>
        `${origin}/api/proxy/v0/meera/blackbox/intranet-widget-bot`,
};
